import React from 'react'

const PaymentsAdmin = () => {
  return (
    <div>PaymentsAdmin</div>
  )
}

export default PaymentsAdmin